<skitbs-template xmlns:h="http://java.sun.com/jsf/core">

    <!-- header -->
    <ng-container facetHeader>
        <div class="White FontBold d-flex f-align-center">
            <a (click)="onWeekPrev()" class="pi pi-angle-left FontBold BsFsXLarge White MarR"></a>
            <a (click)="onWeekCurrent()">
                <span class="BsFsLarge MarH">KW{{modelWeek}}</span>
            </a>
            <a (click)="onWeekNext()" class="pi pi-angle-right FontBold BsFsXLarge White"></a>
        </div>
    </ng-container>

    <!-- content -->
    <ng-container *ngIf=" modelOrdersWeek">

        <skitbs-notifications></skitbs-notifications>

        <!-- prepaid saldo -->
        <div class="TexAlRight MarR FontBold" *ngIf="modelPrepaidSaldo != null">
          <span style="margin-left: 22px">{{this.i18n.v('prepaidSaldo')}}: {{modelPrepaidSaldo | number:'.2-2' }} €</span>
          <span *ngIf="saldoDetails.tableguestPrepaidActive" style="margin-left: 22px"><i class="pi pi-info-circle MarH" (click)="op.toggle($event)"></i>
            <p-overlayPanel #op [dismissable]="true">
                <table border="0">
                  <tr>
                    <td>{{this.i18n.v('saldoFirstDayOfMonth')}} ({{dateFormat(saldoDetails.firstDayOfMonth, 'dd.MM.')}})</td>
                    <td style="text-align: right">{{saldoDetails.monthStartSaldo | number:'.2-2' }} €</td>
                  </tr>
                  <tr>
                    <td>{{this.i18n.v('sumCharges')}} ({{dateFormat(saldoDetails.firstDayOfMonth, 'MMM')}})</td>
                    <td style="text-align: right">{{saldoDetails.amountRecharges | number:'.2-2' }} €</td>
                  </tr>
                  <tr>
                    <td>{{this.i18n.v('ordersThisMonth')}} ({{dateFormat(saldoDetails.firstDayOfMonth, 'MMM')}})</td>
                    <td style="text-align: right">{{saldoDetails.amountOrdersClosed | number:'.2-2' }} €</td>
                  </tr>
                  <tr>
                    <td style="border-bottom: 1px solid black;">{{this.i18n.v('ordersFuture')}} ({{saldoDetails.numberOrdersFuture}})</td>
                    <td style="text-align: right; border-bottom: 1px solid black;">{{saldoDetails.amountOrdersFuture | number:'.2-2' }} €</td>
                  </tr>
                  <tr>
                    <td style="border-bottom: 5px double;">{{this.i18n.v('prepaidSaldo')}}</td>
                    <td style="text-align: right; border-bottom: 5px double;">{{modelPrepaidSaldo | number:'.2-2' }} €</td>
                  </tr>
                </table>
            </p-overlayPanel>
          </span>
        </div>

        <ng-container *ngFor="let pDay of modelOrdersWeek.daysModel">

            <!-- Date -->
            <div style="margin: 22px 0;">
                <div class="BsFsMedium PadL"><b>{{i18n.formatDate(pDay.serviceDay)}} | {{i18n.formatDayName(pDay.serviceDay)}}</b>
                    <span *ngIf="isYesterday(pDay.serviceDay)" class="SoftYellowBack BsFsSmall MarL" style="padding: 0 3px;">({{v('yesterday')}})</span>
                    <span *ngIf="isToday(pDay.serviceDay)" class="YellowBack BsFsSmall MarL" style="padding: 0 3px;">({{v('today')}})</span>
                    <ng-container *ngIf="pDay.dayMessage">{{pDay.dayMessage}}</ng-container>
                </div>
            </div>


            <!--  Mo-Fr -->
            <ng-container *ngFor="let pPlaceholder of pDay.placeholders">
                <div class="d-flex-stretch" style="margin: 12px 0;">

                    <!-- change ordercount -->
                    <div *ngIf="modelMultipleOrders" class="d-flex" style="padding: 12px;">
                        <p-inputNumber
                            [ngModel]="pPlaceholder.quantity"
                            (ngModelChange)="onOrderCountChange($event, pPlaceholder)"
                            (keypress)="onOrderCountKeypress({event: $event, placeholder:pPlaceholder})"
                            [min]="0"
                            [size]="3" inputId="vertical" [showButtons]="true" buttonLayout="vertical" spinnerMode="vertical" decrementButtonClass="GreenBack" incrementButtonClass="GreenBack" incrementButtonIcon="pi pi-plus" decrementButtonIcon="pi pi-minus"
                            [disabled]="pPlaceholder.disableOrdering"

                        >
                        </p-inputNumber>
                    </div>

                    <!-- Check/Uncheck link -->
                    <div *ngIf="!modelMultipleOrders" class="d-flex" style="padding: 12px;">
                        <a (click)="onCancelOrder(pPlaceholder)">
                            <img *ngIf="pPlaceholder.orderPlaced && !pPlaceholder.disableOrdering" src="assets/icons/icon-chk-checked.svg" width="52" height="52"/>
                            <img *ngIf="pPlaceholder.orderPlaced && pPlaceholder.disableOrdering" src="assets/icons/icon-chk-checked-disabled.svg" width="52" height="52"/>
                        </a>

                        <a (click)="onPlaceOrder(pDay, pPlaceholder)">
                            <img *ngIf="!pPlaceholder.orderPlaced && !pPlaceholder.disableOrdering" src="assets/icons/icon-chk-unchecked.svg" width="52" height="52"/>
                            <img *ngIf="!pPlaceholder.orderPlaced && pPlaceholder.disableOrdering" src="assets/icons/icon-chk-unchecked-disabled.svg" width="52" height="52"/>
                        </a>
                    </div>

                    <!-- Menu name -->
                    <div style="width: 10px; min-height: 55px; border-radius: 8px 0 0 8px;" class="GreenBack"></div>
                    <div class="d-col WhiteBack MarR"
                         style="padding: 0 8px; border-radius: 0 8px 8px 0; box-shadow: 0 2px 1px -1px rgb(0 0 0 / 20%), 0 1px 1px 0 rgb(0 0 0 / 14%), 0 1px 3px 0 rgb(0 0 0 / 12%);">
                        <a (click)="onGotoDetails(pPlaceholder)">
                            <div class="FontBold BsFsMedium PadT">{{splitNames(pPlaceholder.menuName)[0]}}</div>
                            <div class="BsTexBreak">{{splitNames(pPlaceholder.menuName)[1]}}</div>
                            <div class="MarB BsFsSmaller">{{pPlaceholder.disableReason}}</div>
                            <div class="MarB BsFsSmaller" *ngIf="pPlaceholder.mealType != 'LUNCH'">({{v(pPlaceholder.mealType)}})</div>
                        </a>
                    </div>
                </div>
            </ng-container>
        </ng-container>
    </ng-container>
    <div class="EmptyBox30"></div>


</skitbs-template>`
